import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import type { FamilyCacheState } from "../types";
import type { ResponseMessage } from "@kiddocare-platform/portal-common/base";
import { isCacheValid } from "../../../entry.cache";
import type { GrowthMeasure } from "@kiddocare-platform/portal-common/family";

const addGrowthMeasures: CaseReducer<
  FamilyCacheState,
  PayloadAction<{ key: string; value: ResponseMessage<GrowthMeasure> }>
> = (state, action) => {
  const { key, value } = action.payload;
  state.growthMeasures[key] = { value, cachedAt: Date.now() };
};

const removeGrowthMeasures: CaseReducer<
  FamilyCacheState,
  PayloadAction<string>
> = (state, action) => {
  delete state.growthMeasures[action.payload];
};

const purgeExpiredGrowthMeasuresCache: CaseReducer<FamilyCacheState> = (state) => {
  for (const key of Object.keys(state.growthMeasures)) {
    if (!isCacheValid(state.growthMeasures[key])) {
      delete state.growthMeasures[key];
    }
  }
};

export const growthMeasuresReducers = {
  addGrowthMeasures,
  removeGrowthMeasures,
  purgeExpiredGrowthMeasuresCache,
};
